import React from 'react';
import NumericInput, { NumericInputProps } from '../NumericInput';

export type AppPercentageInputProps = Omit<NumericInputProps, 'thousandSeparator'>;

/**
 * Percentage input. Sanitised numeric text field with a "%" suffix (override
 * via `suffix` if the screen renders its own) and no thousand separators
 * ("12.5" stays "12.5"). Commits the cleaned numeric string to the form.
 */
const AppPercentageInput: React.FC<AppPercentageInputProps> = ({
  suffix = '%',
  ...rest
}) => <NumericInput {...rest} suffix={suffix} thousandSeparator={false} />;

export default AppPercentageInput;
